import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";

import {ToasterService} from "angular2-toaster";

import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {DataService, OrientDBCollectionView} from "@cosbeni/database";

@Component({
    selector: 'cj-admin-customer',
    templateUrl: 'customer-management.component.html',
})

export class CustomerManagementComponent implements OnInit {
    readonly: Boolean = true;
    @ViewChild('customerGrid') customerGrid: wjcGrid.FlexGrid;
    customers: OrientDBCollectionView;
    vertexes: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService) {
        this.customers = new OrientDBCollectionView(dataService, KaitoriyaConfig.DATABASE, "SELECT FROM AP_Customer", "AP_Customer", "", 0, 100, true, true, false)
        this.customers.url = KaitoriyaConfig.SERVER_URL;
        this.customers.tokenName = KaitoriyaConfig.DATABASE + "_token";
    }

    ngOnInit() {
        this.customers.currentChanged.addHandler(this.onCurrentChanged, this);
        this.customers.filterOnServer = true;
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
    }

    refresh(grid: string): void {
        this[grid].invalidate();
    }

}

